// Generated by purs version 0.15.4
import * as PartyCarlo_Store from "../PartyCarlo.Store/index.js";
var env = /* #__PURE__ */ (function () {
    return PartyCarlo_Store.Prod.value;
})();
export {
    env
};
